import { render, staticRenderFns } from "./h8-table-grid.vue?vue&type=template&id=3dfd5000&"
import script from "./h8-table-grid.component.ts?vue&type=script&lang=ts&"
export * from "./h8-table-grid.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/h8udm/release-builds/release-2.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dfd5000')) {
      api.createRecord('3dfd5000', component.options)
    } else {
      api.reload('3dfd5000', component.options)
    }
    module.hot.accept("./h8-table-grid.vue?vue&type=template&id=3dfd5000&", function () {
      api.rerender('3dfd5000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/h8-component/h8-table-grid.vue"
export default component.exports